import { CALENDAR_FLEX_MODE } from "../variables/calendar"
import { ddmmyyyyformatDate } from "./format"

export const getDaysInMonth = (date) => {
  const year = date.getFullYear()
  const month = date.getMonth()
  const firstDay = new Date(year, month, 1)
  const lastDay = new Date(year, month + 1, 0)
  const daysInMonth = lastDay.getDate()
  const startingDayOfWeek = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1

  return { daysInMonth, startingDayOfWeek }
}

export const isDateSelected = (day, date, selectedDates) => {
  const formattedDate = ddmmyyyyformatDate(day, date)
  const dates = Array.isArray(selectedDates) ? selectedDates : []
  return dates.includes(formattedDate)
}

export const isDateInRange = (day, date, selectedDates, mode) => {
  if (mode !== CALENDAR_FLEX_MODE) return false

  const formattedDate = ddmmyyyyformatDate(day, date)
  const dates = Array.isArray(selectedDates) ? selectedDates : []

  if (dates.length < 2) return false

  const sortedDates = [...dates].sort()
  const firstDate = sortedDates[0]
  const lastDate = sortedDates[sortedDates.length - 1]

  return formattedDate !== firstDate && formattedDate !== lastDate && dates.includes(formattedDate)
}
